// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uzUnf","image":"Header_image__YFfBY","name":"Header_name__j_K-2","info":"Header_info__QAMa9","infoRow":"Header_infoRow__1u-7F"};